import React from 'react';
import { X, Zap } from 'lucide-react';
import MacroLibraryPanel from './MacroLibraryPanel';

// Quick access to the response library without leaving the case you are
// working on — the case stays behind the drawer, untouched.
export default function MacroDrawer({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex justify-end">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="animate-macro-drawer relative w-full max-w-xl h-full bg-[#0d0d0f] border-l border-white/10 overflow-y-auto">
        <div className="sticky top-0 flex items-center justify-between gap-3 px-5 py-4 border-b border-white/5 bg-[#0d0d0f]">
          <div className="flex items-center gap-2 min-w-0">
            <Zap className="w-4 h-4 text-primary shrink-0" />
            <p className="text-white text-xs font-bold tracking-widest truncate">
              CANNED RESPONSES
            </p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-white/40 hover:text-white transition-colors shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-5">
          <MacroLibraryPanel />
        </div>
      </div>
    </div>
  );
}